import { useSorting } from 'components/SortingArrow';
import { Sorter } from 'components/SortingArrow/helpers';
import { SORT_ASC, SORT_DESC, SortDirection } from 'constants/sorting';
import { MASS_EMAIL_SORTABLE_FIELDS, MassEmailSortableField, SORT_BY_SEND_DATE } from 'services/api/mailer';

export type MassEmailSortingState = [
  MassEmailSortableField,
  SortDirection,
  { [field: string]: Sorter },
];

export default function useMassEmailSorting(): MassEmailSortingState {
  const [
    sortBy,
    sortDirection,
    sorters,
  ] = useSorting<MassEmailSortableField | undefined>(MASS_EMAIL_SORTABLE_FIELDS, SORT_DESC);

  // SORT_ASC aqui é o "destino" do ciclo de clique da seta (ver nextDirection em
  // components/SortingArrow/helpers) quando a direção volta a undefined — não o
  // default da tela. O default inicial (DESC) já vem do initialDirection acima.
  return [
    sortBy || SORT_BY_SEND_DATE,
    sortDirection || SORT_ASC,
    sorters,
  ];
}
